// Editors write `{n}` (Strapi helper text), not the `{count}` the built-in translations use.
const COUNT_PLACEHOLDER = /\{n\}/g;

/** An override without `{n}` renders as entered — the count is not appended (CMS-2051). */
export const resolveRewardToggleViewAllLabel = (
  override: string | undefined,
  count: number,
): string | undefined => {
  const label = override?.trim();
  if (!label) {
    return undefined;
  }
  return label.replace(COUNT_PLACEHOLDER, String(count));
};
